import { EntityForm } from "../../components/entityForm/EntityForm";
import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { DynamicTasksForm } from "./DynamicTasksForm";
import { DynamicTasksGroupsLayout } from "./DynamicTasksGroupsLayout";
import { DynamicTasksDetailHeader } from "./department-validation/DynamicTasksDetailHeader";
import { DynamicTasksEditGuard } from "./department-validation/DynamicTasksEditGuard";
import { dynamicTasksDetailGroupsOptions, dynamicTasksOptions } from "./dynamicTasksOptions";

const fieldsQuery = "*.*,assigned_users.*,participant_users.directus_users_id.*";

export const dynamicTasksRoutes = [
	{
		path: "/dynamic_tasks",
		element: (
			<Records entity="dynamic_tasks" fieldsQuery={fieldsQuery} options={dynamicTasksOptions} heightOfHeaders={190} />
		),
	},
	{
		path: "/dynamic_tasks/:id/detail",
		element: (
			<Record
				entity="dynamic_tasks"
				type="detail"
				fieldsQuery={fieldsQuery}
				options={dynamicTasksOptions.groupsOptions}
				header={<DynamicTasksDetailHeader />}
				body={<DynamicTasksGroupsLayout groupsOptions={dynamicTasksDetailGroupsOptions} />}
			/>
		),
	},
	{
		path: "/dynamic_tasks/:id/update",
		element: (
			<Record
				entity="dynamic_tasks"
				type="update"
				fieldsQuery={fieldsQuery}
				options={dynamicTasksOptions.groupsOptions}
				body={
					<DynamicTasksEditGuard>
						<EntityForm groupsOptions={dynamicTasksOptions.groupsOptions} component={<DynamicTasksForm />} />
					</DynamicTasksEditGuard>
				}
			/>
		),
	},
	{
		path: "/dynamic_tasks/create",
		element: (
			<Record
				entity="dynamic_tasks"
				type="create"
				fieldsQuery={fieldsQuery}
				options={dynamicTasksOptions.groupsOptions}
				body={<EntityForm groupsOptions={dynamicTasksOptions.groupsOptions} component={<DynamicTasksForm />} />}
			/>
		),
	},
];
